import React from 'react';
import { ToggleButton as ToggleButtonBs } from 'react-bootstrap';
import { Icon } from '../KeyComponents';

export { default as ToggleButtonGroup } from 'react-bootstrap/ToggleButtonGroup';

function ToggleButton(props) {
  return (
    <ToggleButtonBs {...props}>
      {props.iconBefore && <Icon icon={props.iconBefore} type={props.iconType} />}
      {props.children}
    </ToggleButtonBs>
  );
}

export default ToggleButton;
